export default "__VITE_ASSET__8a41bfaf__"